import { render, staticRenderFns } from "./ExtendedSearch.vue?vue&type=template&id=65656e86"
import script from "./ExtendedSearch.vue?vue&type=script&lang=js"
export * from "./ExtendedSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports